import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { ErrorBanner, InfoBanner, SuccessBanner, WarningBanner } from './Banner.components';
import { Button } from '../Button';
import { ICross2, IError, IInfo, ITick2, IWarning } from '../Iconography';
import { HelixPalette, HelixStyles } from '../../helix';
import { HELIX_REACT_CORE_TRANSLATION_NAMESPACE } from '../../locales';
/**
 * Simple informative banner.
 */
export const Banner = ({ cancellable = false, content, dataId, message, style, type = 'information' }) => {
    // Hooks.
    const { t } = useTranslation();
    const [cancelled, setCancelled] = useState(false);
    // Base style for the icon.
    const iconAttr = { marginRight: '0.75rem' };
    // The content to display in the banner, content takes precedence over message.
    const contentNode = content ? (_jsx(Box, Object.assign({ "data-id": `${dataId}-custom-content`, width: "100%", alignContent: "center" }, { children: content }))) : (_jsx(Box, Object.assign({ width: "100%", alignContent: "center" }, { children: _jsx(Typography, Object.assign({}, HelixStyles.style_07, { "data-id": `${dataId}-message`, sx: { wordBreak: 'break-word' } }, { children: message })) })));
    // The display stype value.
    const display = useMemo(() => (cancelled ? 'none' : undefined), [cancelled]);
    // The cancel Button.
    const cancelButton = (_jsx(Button, { dataId: `${dataId}-cancel-banner`, leftIcon: _jsx(ICross2, {}), title: t('commands.close', { ns: HELIX_REACT_CORE_TRANSLATION_NAMESPACE }), onClick: () => setCancelled(true), type: "universal", style: { marginLeft: '1rem' } }));
    // Display the correct type.
    switch (type) {
        case 'error':
            return (_jsxs(ErrorBanner, Object.assign({ "data-id": `${dataId}-error-banner`, sx: Object.assign(Object.assign({}, style), { display }) }, { children: [_jsx(IError, { color: HelixPalette.red60, style: iconAttr }), contentNode, cancellable && cancelButton] })));
        case 'success':
            return (_jsxs(SuccessBanner, Object.assign({ "data-id": `${dataId}-success-banner`, sx: Object.assign(Object.assign({}, style), { display }) }, { children: [_jsx(ITick2, { color: HelixPalette.green90, style: iconAttr }), contentNode, cancellable && cancelButton] })));
        case 'warning':
            return (_jsxs(WarningBanner, Object.assign({ "data-id": `${dataId}-warning-banner`, sx: Object.assign(Object.assign({}, style), { display }) }, { children: [_jsx(IWarning, { color: HelixPalette.yellow50, style: iconAttr }), contentNode, cancellable && cancelButton] })));
        default:
            return (_jsxs(InfoBanner, Object.assign({ "data-id": `${dataId}-info-banner`, sx: Object.assign(Object.assign({}, style), { display }) }, { children: [_jsx(IInfo, { color: HelixPalette.teal70, style: iconAttr }), contentNode, cancellable && cancelButton] })));
    }
};
export default Banner;
